(function () {
    'use strict';
    $(document).ready(function () {

        $(".play-video").modalVideo({
            channel: 'vimeo'
        });

        const swiperAbout = new Swiper('.swiper.swiper-about', {
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            pagination : {
                el: '.swiper-pagination',
                clickable: true,
                renderBullet: function (index, className) {
                    return '<span class="' + className + '">' + (index + 1) + '</span>';
                },
            }
        });

    });
}(jQuery));
